import { z } from "zod";
import { MethodTypeEnum, ModuleTypeEnum } from "@/enum";

export const ToolSchema = z.object({
  id: z.string(),
  name: z.string().min(1, "Nome é obrigatório."),
  apiUrl: z.string().min(1, "URL é obrigatória."),
  description: z.string().min(1, "Descrição obrigatória."),
  methodType: z.nativeEnum(MethodTypeEnum, {
    required_error: "O tipo do método é obrigatório.",
  }),

  type: z.nativeEnum(ModuleTypeEnum, {
    required_error: "O tipo é obrigatório.",
  }),

  updated_at: z.string().datetime().nullable().optional(),
  deleted_at: z.string().datetime().nullable().optional(),
});

export const CreateAiConfigurationFormSchema = z.object({
  aiConfigurationId: z.string(),
  apiUrl: z.string().min(1, { message: "A URL é obrigatória." }),

  description: z.string().min(1, { message: "A descrição é obrigatória." }),

  type: z.nativeEnum(ModuleTypeEnum, {
    required_error: "O tipo da configuração é obrigatório.",
  }),

  tools: z.array(ToolSchema).default([]),
});

export type CreateAiConfigurationData = z.infer<
  typeof CreateAiConfigurationFormSchema
>;
